import styled from 'styled-components';

export const SubNavWrapper = styled.div`
	position: relative;
`;
